import axios from 'axios';
import { urlsServices } from '@/config/urls';
import queryString from 'query-string';

let httpUrl = `${urlsServices.GETWAY}api/painel-piscologia/list?page=0&size=10`;

export function getChamados(queryParams) {
  const queryStringResult = queryString.stringify(queryParams);
  console.log(`${httpUrl}&${queryStringResult}`);
  return axios.get(`${httpUrl}&${queryStringResult}`);
}

// const mockData = [
//   {
//     "horaRegistro": "2023-07-31T08:15:30",
//     "ordemChamada": "1",
//     "rgPaciente": "612561",
//     "medico": "Joao Silva",
//     "sala": "4"
//   },
//   {
//     "horaRegistro": "2023-08-01T09:30:45",
//     "ordemChamada": "2",
//     "rgPaciente": "4567",
//     "medico": "Pedro Maria",
//     "sala": "1"
//   },
//   {
//     "horaRegistro": "2023-08-02T10:45:10",
//     "ordemChamada": "3",
//     "rgPaciente": "78901",
//     "medico": "Ana Souza",
//     "sala": "3"
//   },
//   {
//     "horaRegistro": "2023-08-03T12:00:25",
//     "ordemChamada": "4",
//     "rgPaciente": "23456",
//     "medico": "Carlos Santos",
//     "sala": "2"
//   },
//   {
//     "horaRegistro": "2023-08-04T13:15:50",
//     "ordemChamada": "5",
//     "rgPaciente": "99999",
//     "medico": "Laura Ferreira",
//     "sala": "6"
//   },
//   {
//     "horaRegistro": "2023-08-05T14:30:15",
//     "ordemChamada": "6",
//     "rgPaciente": "12345",
//     "medico": "Fernando Costa",
//     "sala": "4"
//   },
//   {
//     "horaRegistro": "2023-08-06T15:45:30",
//     "ordemChamada": "7",
//     "rgPaciente": "77777",
//     "medico": "Mariana Oliveira",
//     "sala": "3"
//   },
//   {
//     "horaRegistro": "2023-08-07T17:00:45",
//     "ordemChamada": "8",
//     "rgPaciente": "54321",
//     "medico": "Rodrigo Silva",
//     "sala": "5"
//   },
//   {
//     "horaRegistro": "2023-08-08T18:15:00",
//     "ordemChamada": "9",
//     "rgPaciente": "88888",
//     "medico": "Camila Sousa",
//     "sala": "2"
//   },
//   {
//     "horaRegistro": "2023-08-09T19:30:15",
//     "ordemChamada": "10",
//     "rgPaciente": "11111",
//     "medico": "Paulo Mendes",
//     "sala": "1"
//   },
//   {
//     "horaRegistro": "2023-08-10T20:45:30",
//     "ordemChamada": "11",
//     "rgPaciente": "22222",
//     "medico": "Rafaela Santos",
//     "sala": "6"
//   },
//   {
//     "horaRegistro": "2023-08-11T22:00:45",
//     "ordemChamada": "12",
//     "rgPaciente": "33333",
//     "medico": "Beatriz Almeida",
//     "sala": "4"
//   }
// ]

// export const getChamados = async (queryParams) => {
//   const { medico, rgPaciente, dtInicio, dtFim } = queryParams;

//   // Filtre os dados com base nos parâmetros de consulta
//   const filtered = mockData.filter((chamado) => {
//       // Verifique se o parâmetro "medico" corresponde ao médico no chamado
//       const medicoMatch = !medico || chamado.medico.toLowerCase().includes(medico.toLowerCase());
//       // Verifique se o parâmetro "rgPaciente" corresponde ao RG do paciente no chamado
//       const rgPacienteMatch = !rgPaciente || chamado.rgpaciente === rgPaciente;
//       // Verifique se a data de chamado está entre as datas de início e fim (se fornecidas)
//       const dataChamado = new Date(chamado.horaRegistro).getTime();
//       const dtInicioTimestamp = dtInicio ? new Date(dtInicio).getTime() : 0;
//       const dtFimTimestamp = dtFim ? new Date(dtFim).getTime() : Number.MAX_SAFE_INTEGER;
//       const dataChamadoInRange = dataChamado >= dtInicioTimestamp && dataChamado <= dtFimTimestamp;

//       // Retorna verdadeiro se todos os filtros corresponderem, ou seja, o chamado passa pelos filtros
//       return medicoMatch && rgPacienteMatch && dataChamadoInRange;
//     });
//     return {
//         data: {
//             content: filtered
//         }
//     }
// };
